import {Component} from '@angular/core';
import {ConsoleContextService} from "src/app/security/console-context.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";

@Component({
  selector: 'app-pre-auth-toolbar',
  templateUrl: './pre-auth-toolbar.component.html',
})
export class PreAuthToolbarComponent {
  landlordLogo: string = '../assets/icons/default-nter-logo.svg';

  loading$ = this.loader.loading$;

  constructor(private currentContext: ConsoleContextService, public loader: LoadingService) {
    setTimeout(() => {
      this.currentContext.getCurrentWebClient()
        .then((response) => {
          if (response) {
            this.landlordLogo = response.companyLogo!;
          }
        });
    }, 300)
  }

}
